module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Bold-85d6f73bf73d0351846108dbf2c56619.ttf";